import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

export function useEntityDetail(entityType: string, id: string, appSlug?: string) {
    const basePath = appSlug
        ? `/applications/${appSlug}/${entityType}/${id}`
        : `/${entityType}/${id}`;

    return useQuery({
        queryKey: [entityType, id, appSlug],
        queryFn: () => api.get(basePath).then((r) => r.data),
        enabled: !!id,
    });
}

export function useCapabilityDetail(appKey: string, name: string) {
    return useQuery({
        queryKey: ['capability', appKey, name],
        queryFn: () =>
            api.get(`/applications/${appKey}/capabilities/${name}`).then((r) => r.data),
        enabled: !!appKey && !!name,
    });
}

export function useCapabilityDetailByID(id: string) {
    return useQuery({
        queryKey: ['capability', id],
        queryFn: () => api.get(`/capabilities/${id}`).then((r) => r.data),
        enabled: !!id,
    });
}

export function useApplicationDetail(appKey: string) {
    return useQuery({
        queryKey: ['application', appKey],
        queryFn: () => api.get(`/applications/${appKey}`).then((r) => r.data),
        enabled: !!appKey,
    });
}

export function useRevisions(appKey: string, name: string) {
    return useQuery({
        queryKey: ['revisions', appKey, name],
        queryFn: () =>
            api.get(`/applications/${appKey}/capabilities/${name}/revisions`).then((r) => r.data),
        enabled: !!appKey && !!name,
    });
}

export function useMethods(appKey: string, name: string, revisionId: string) {
    return useQuery({
        queryKey: ['methods', revisionId],
        queryFn: () =>
            api
                .get(
                    `/applications/${appKey}/capabilities/${name}/revisions/${revisionId}/methods`,
                )
                .then((r) => r.data),
        enabled: !!revisionId,
    });
}

export function useRevisionFiles(appKey: string, name: string, revisionId: string) {
    return useQuery({
        queryKey: ['revision-files', revisionId],
        queryFn: () =>
            api
                .get(
                    `/applications/${appKey}/capabilities/${name}/revisions/${revisionId}/files`,
                )
                .then((r) => r.data),
        enabled: !!revisionId,
    });
}
